
import React from 'react';
import ResourcePageLayout from '@/components/layouts/ResourcePageLayout';

const PrivacyPolicy = () => {
  const lastUpdated = "May 15, 2023";
  
  const sections = [
    {
      title: "Data Collection",
      content: "We collect information you provide directly to us when you create an account, fill out forms, participate in surveys, or communicate with us. This may include your name, email address, date of birth, gender, health information, and other details relevant to hormonal health. We also automatically collect certain information when you use our services, including your IP address, browser type, operating system, and usage data."
    },
    {
      title: "How We Use Your Data",
      content: "We use your information to provide, maintain, and improve our services; to develop new features and functionality; to process transactions; to communicate with you about your account, services, promotions, and events; to respond to your inquiries; to monitor and analyze trends, usage, and activities; to detect, prevent, and address fraud or security issues; and to comply with legal obligations."
    },
    {
      title: "Your Rights",
      content: "Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, delete, restrict processing of, and object to our processing of your data. You may also have the right to receive a copy of your personal information in a structured, machine-readable format. To exercise these rights, please contact us using the information provided at the end of this policy."
    },
    {
      title: "Security Measures",
      content: "We implement appropriate technical and organizational measures to protect the security of your personal information. However, please note that no method of transmission over the internet or electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security."
    },
    {
      title: "Data Retention",
      content: "We retain your personal information for as long as necessary to provide you with our services and as needed to comply with our legal obligations, resolve disputes, and enforce our agreements. The criteria used to determine our retention periods include the length of time we have an ongoing relationship with you, our legal obligations, and the nature of the data collected."
    },
    {
      title: "Contact Information for Privacy Concerns",
      content: "If you have any questions or concerns about our privacy practices or this Privacy Policy, please contact us at privacy@hormonebalanceguide.com or write to us at: Hormone Balance Guide Privacy Office, 123 Wellness Avenue, San Francisco, CA 94110."
    }
  ];
  
  return (
    <ResourcePageLayout 
      title="Privacy Policy" 
      description="Your privacy is important to us. Here's how we protect your personal information."
    >
      <div className="bg-white p-6 rounded-lg border border-Hormone Balance Guide-beige/50 mb-6">
        <p className="text-sm text-Hormone Balance Guide-charcoal/70">Last Updated: {lastUpdated}</p>
        <p className="mt-4 text-Hormone Balance Guide-charcoal/80">
          This Privacy Policy describes how Hormone Balance Guide ("we", "our", or "us") collects, uses, and shares your personal information when you use our website, mobile application, and services (collectively, the "Services"). By using our Services, you agree to the collection and use of information in accordance with this policy.
        </p>
      </div>
      
      <div className="space-y-6">
        {sections.map((section, index) => (
          <div key={index} className="bg-white p-6 rounded-lg border border-Hormone Balance Guide-beige/50">
            <h3 className="text-xl font-semibold text-Hormone Balance Guide-charcoal mb-3">{section.title}</h3>
            <p className="text-Hormone Balance Guide-charcoal/80">{section.content}</p>
          </div>
        ))}
      </div>
    </ResourcePageLayout>
  );
};

export default PrivacyPolicy;
